import type { ReactNode } from 'react'
import { TopNav } from './TopNav'
import { AdminSidebar } from './AdminSidebar'

interface PageLayoutProps {
  children: ReactNode
}

export function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className="min-h-screen bg-[#f9f4ff] dark:bg-[#0f0d12] transition-colors">
      <TopNav />
      <AdminSidebar />
      <main className="ml-64 mt-20 p-8">
        <div className="animate-fade-in">
          {children}
        </div>
      </main>
    </div>
  )
}
